/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  InboundFaxListResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InboundFaxListResponseDtoFromJSON,
    InboundFaxListResponseDtoToJSON,
} from '../models/index';

export interface ListCurrentPatientFaxesRequest {
    page?: number;
    pageSize?: number;
}

export interface ListPatientFaxesRequest {
    patientId: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class FaxesPatientApi extends runtime.BaseAPI {

    /**
     * Patient-only endpoint for the Diagnostics tab. Returns inbound faxes assigned to the authenticated patient.
     * List inbound faxes assigned to the current patient
     */
    async listCurrentPatientFaxesRaw(requestParameters: ListCurrentPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/me/faxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Patient-only endpoint for the Diagnostics tab. Returns inbound faxes assigned to the authenticated patient.
     * List inbound faxes assigned to the current patient
     */
    async listCurrentPatientFaxes(requestParameters: ListCurrentPatientFaxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxListResponseDto> {
        const response = await this.listCurrentPatientFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns inbound faxes assigned to a patient for the provider Diagnostics tab. Results are scoped to the provider\'s current practice.
     * List inbound faxes assigned to a patient
     */
    async listPatientFaxesRaw(requestParameters: ListPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InboundFaxListResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling listPatientFaxes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/{patientId}/faxes`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InboundFaxListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns inbound faxes assigned to a patient for the provider Diagnostics tab. Results are scoped to the provider\'s current practice.
     * List inbound faxes assigned to a patient
     */
    async listPatientFaxes(requestParameters: ListPatientFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InboundFaxListResponseDto> {
        const response = await this.listPatientFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
